import './index.css';
import * as serviceWorker from './serviceWorker';
import App from './components/app/App';
import React from 'react';
import ReactDOM from 'react-dom';


const render = () => {
  ReactDOM.render(<App />, document.getElementById('root'));
};


render();


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

